// extracted by mini-css-extract-plugin
export default {"list":"ancillary-select-row_list__GP4gX"};